import {useShippingMethodsForShipment} from '@salesforce/commerce-sdk-react'

const formatDate = (date) => {
    const day = String(date.getDate()).padStart(2, '0')
    const month = String(date.getMonth() + 1).padStart(2, '0') // Months are zero-indexed
    const year = date.getFullYear()
    return `${day}.${month}.${year}`
}

export const useEstimatedDate = ({basket}) => {
    const shippingMethod = basket?.shipments[0].shippingMethod?.id

    // delivery dates from the lagecy logic.
    const now = new Date()
    let estimatedStartDate = new Date(basket?.c_deliveryDateMin ? basket?.c_deliveryDateMin : now)
    let estimatedEndDate = new Date(basket?.c_deliveryDateMax ? basket?.c_deliveryDateMax : now)
    let expressDate = new Date(basket?.c_deliveryDateMin ? basket?.c_deliveryDateMin : now)

    // delivery dates from the new enhanched logic.
    const {data: shippingMethods} = useShippingMethodsForShipment({
        parameters: {
            basketId: basket?.basketId,
            shipmentId: 'me'
        }
    })
    const applicableMethods = shippingMethods?.applicableShippingMethods || []
    const defaultId = shippingMethods?.defaultShippingMethodId

    const defaultMethod = applicableMethods.find((method) => method.id === defaultId)
    const expressMethod = applicableMethods.find((method) => method.id?.includes('express'))

    const minDay = defaultMethod?.c_minDays
    const maxDay = defaultMethod?.c_maxDays
    const expressMinDay = expressMethod?.c_minDays

    if (minDay) {
        estimatedStartDate = new Date(now)
        estimatedStartDate.setDate(now.getDate() + minDay)
    }
    if (maxDay) {
        estimatedEndDate = new Date(now)
        estimatedEndDate.setDate(now.getDate() + maxDay)
    }
    if (expressMinDay) {
        expressDate = new Date(now)
        expressDate.setDate(now.getDate() + expressMinDay)
    }

    return {
        estimatedStartDate: formatDate(estimatedStartDate),
        estimatedEndDate: formatDate(estimatedEndDate),
        expressDate: formatDate(expressDate),
        shippingMethod: shippingMethod
    }
}
